import Hero from "./Pages/Hero";
import Main from "./Pages/Main";
import Contact from "./Pages/Contact";
import Footer from "./Pages/Footer";
import Skills from "./Pages/Skills";
import NotFound from './Pages/NotFound';
import { useEffect, useState } from "react";
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

function App() {
  useEffect(() => {
    window.addEventListener("scroll", () => {
      if (window.scrollY > 300) {
        setshowScrollBTN(true);
      } else {
        setshowScrollBTN(false);
      }
    });
  }, []);

  const [showScrollBTN, setshowScrollBTN] = useState(false);
  return (
    <>

      <div id="up" className="container ">
        <Router>
          <Routes>
            <Route path="/"  element={<Hero />} />
            <Route path="/Skills" element={<Skills />} />
            <Route path="/Main" element={<Main />} />

            <Route path="/Contact-Me" element={<Contact />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Router>
        <Footer />



        <a style={{ opacity: showScrollBTN ? 1 : 0, transition: "1s" }} href="#up">
          <button className="icon-keyboard_arrow_up scroll2Top"></button>
        </a>
      </div>

    </>
  );
}

export default App;
